import * as React from 'react';
import { injectIntl, InjectedIntl } from 'react-intl';

type Props = {
    readonly children: (intl: InjectedIntl) => JSX.Element;
};

export const WithIntl: React.ComponentType<Props> = injectIntl<Props>(({ children, intl }) => children(intl));
